export default "__VITE_PUBLIC_ASSET__d62128ea__"